// TUTORIAL: the profile half of the first-time hints (src/app/tutorial.ts). Kept apart so save.ts stays light.
// profile.tips is OPTIONAL (no SAVE_VERSION bump): a save without it reads as "nothing seen yet, tips on".
export type TipId = 'levelup' | 'surge' | 'evolve' | 'fusion' | 'chest' | 'cache' | 'elite' | 'bossTele' | 'wall';
export const TIP_IDS: readonly TipId[] = ['levelup', 'surge', 'evolve', 'fusion', 'chest', 'cache', 'elite', 'bossTele', 'wall'];

/** profile.tips (optional, no version bump): every field optional too */
export interface TipsSave {
  /** Settings › Tips: Off */
  off?: boolean;
  /** hints already shown */
  seen?: TipId[];
  /** the first-launch "try the Basics lesson?" offer has been answered */
  offered?: boolean;
  /** the Basics lesson was finished once */
  lessonDone?: boolean;
}
/** the slice of the profile this file reads and writes */
export interface TipsHolder { tips?: TipsSave }

/** sanitise a stored / imported block; undefined when there is nothing worth keeping */
export function migrateTips(raw: unknown): TipsSave | undefined {
  if (!raw || typeof raw !== 'object') return undefined;
  const r = raw as Record<string, unknown>, out: TipsSave = {};
  if (r.off === true) out.off = true;
  if (Array.isArray(r.seen)) { const s = [...new Set(r.seen.filter((x): x is TipId => TIP_IDS.includes(x as TipId)))]; if (s.length) out.seen = s; }
  if (r.offered === true) out.offered = true;
  if (r.lessonDone === true) out.lessonDone = true;
  return Object.keys(out).length ? out : undefined;
}
const block = (p: TipsHolder): TipsSave => (p.tips ??= {});
export const tipsOn = (p: TipsHolder): boolean => !p.tips?.off;
export function setTipsOn(p: TipsHolder, on: boolean): void { if (on) { if (p.tips) delete p.tips.off; } else block(p).off = true; }
export const tipSeen = (p: TipsHolder, id: TipId): boolean => !!p.tips?.seen?.includes(id);
/** remember a hint as shown; false if it already was */
export function markTip(p: TipsHolder, id: TipId): boolean {
  if (tipSeen(p, id)) return false;
  const b = block(p); (b.seen ??= []).push(id); return true;
}
/** Settings › Reset tips: every hint shows again, and the Basics lesson is offered again on the next visit to the title */
export function resetTips(p: TipsHolder): void { if (!p.tips) return; delete p.tips.seen; delete p.tips.offered; }
/** should the title offer the Basics lesson? */
export const lessonOfferDue = (p: TipsHolder): boolean => !p.tips?.offered;
export function markOffered(p: TipsHolder): void { block(p).offered = true; }
export function markLessonDone(p: TipsHolder): void { const b = block(p); b.lessonDone = true; b.offered = true; }
